import CloseIcon from "@mui/icons-material/Close";
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem,
  TextField,
} from "@mui/material";
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearUser, setUser } from "../../../store/reducers/userReducer";
const LoginButton = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const snackbar = useSnackbar();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [open, setOpen] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);

  const user = useSelector((state) => state.user.user);


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEmail("");
    setPassword("");
  };

  useEffect(() => {
    if (user?.token) {
      try {
        const decodedToken = jwtDecode(user.token);
        const expirationTime = decodedToken.exp * 1000; // Convert to milliseconds
        const currentTime = Date.now();
  
        // Set a timeout to log out the user when the token expires
        const timeUntilExpiry = expirationTime - currentTime;
        if (timeUntilExpiry > 0) {
          const logoutTimer = setTimeout(() => {
            dispatch(clearUser());
            enqueueSnackbar("Session expired. Please log in again.", {
              variant: "warning",
              autoHideDuration: 3000,
            });
          }, timeUntilExpiry);
          
          // Cleanup on unmount or user change
          return () => clearTimeout(logoutTimer);
        } else {
          enqueueSnackbar("Session expired. Please log in again.", {
            variant: "warning",
            autoHideDuration: 3000,
          })
          // Token already expired, log out immediately
          dispatch(clearUser());
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        dispatch(clearUser());
      }
    }
  }, [user?.token, dispatch]);

  const handleGoogleSuccess = async (credentialResponse) => {
    const decoded = jwtDecode(credentialResponse.credential);
  
    if (!decoded) {
      enqueueSnackbar("Google authentication failed!", {
        variant: "error",
        autoHideDuration: 2000,
      });
      return;
    }
  
    try {
      const response = await axios.post("/auth/google", {
        token: credentialResponse.credential,
      });
  
      if (response.status === 200) {
        enqueueSnackbar("Logged in with Google successfully!", {
          variant: "success",
          autoHideDuration: 2000,
        });
  
        dispatch(
          setUser({
            email: decoded.email,
            token: response.data.token,
            likedProducts: [],
          })
        );
  
        handleClose();
      } else {
        enqueueSnackbar(response.data.message || "Google login failed!", {
          variant: "error",
          autoHideDuration: 2000,
        });
      }
    } catch (error) {
      enqueueSnackbar(error.response?.data?.message || "Google login failed!", {
        variant: "error",
        autoHideDuration: 2000,
      });
    }
  };
  

  const handleLogin = async () => {
    if (!email || !password) {
      enqueueSnackbar("Email or password cannot be empty!", {
        variant: "error",
        autoHideDuration: 2000,
      });
      return;
    }

    try {
      const response = await axios.post("/login", { email, password });

      if (response.status === 200) {
        enqueueSnackbar("Logged in successfully!", {
          variant: "success",
          autoHideDuration: 2000,
        });

        dispatch(
          setUser({
            email,
            token: response.data.token,
            likedProducts: [],
          })
        );

        handleClose();
      } else {
        enqueueSnackbar(response.data.message, {
          variant: "error",
          autoHideDuration: 2000,
        });
      }
    } catch (error) {
      enqueueSnackbar(error.response?.data?.message || "Login failed!", {
        variant: "error",
        autoHideDuration: 2000,
      });
    }
  };

  const handleLogout = () => {
    dispatch(clearUser());
    enqueueSnackbar("Goodbye!", { variant: "success", autoHideDuration: 2000 });
    setMenuAnchor(null);
  };

  const handleAvatarClick = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  return (
    <Box sx={{ paddingTop: "3px", display: "flex", alignItems: "center", gap: 2 }}>
      {user.isLoggedIn ? (
        <>
          <IconButton onClick={handleAvatarClick}>
            <Avatar sx={{ backgroundColor: "#db9c97" }}>
              {user.email.charAt(0).toUpperCase()}
            </Avatar>
          </IconButton>

          <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={handleMenuClose}>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </>
      ) : (
        <Button
          variant="contained"
          onClick={handleClickOpen}
          sx={{
            borderRadius: "20px",
            backgroundColor: "#d7d9d7",
            width: "100px",
            height: "40px",
            color: "black",
            "&:hover": { backgroundColor: "#b7bdb7" },
          }}
        >
          Log In
        </Button>
      )}

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          Login
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Email"
            type="email"
            fullWidth
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Password"
            type="password"
            fullWidth
            variant="outlined"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <Box sx={{ mt: 3, textAlign: "center" }}>
            <GoogleOAuthProvider clientId="16170073933-hpq58n4hljb49pla98rp2p95sbt1dj1g.apps.googleusercontent.com">
            <Box 
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <GoogleLogin
                  onSuccess={handleGoogleSuccess}
                  onError={() => snackbar.enqueueSnackbar("Google Sign-In Failed", { variant: "error" })}
                  theme="outline"
                  width="300px"
                  text="continue_with"
                  shape="pill"
                />
              </Box>
            </GoogleOAuthProvider>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", paddingBottom: "16px" }}>
          <Button
            onClick={handleLogin}
            sx={{
              backgroundColor: "orange",
              color: "white",
              width: "150px",
              height: "50px",
              "&:hover": { backgroundColor: "darkorange" },
            }}
          >
            Log In
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default LoginButton;
